export const telemetrySchemaVersion = 1

export type LearningTelemetryContext = Readonly<{
  bucket: 'difficult' | 'mastered' | 'studying'
  modeId: 'auto-play' | 'flashcards'
  modeVersion: number
  sourceKind: 'group' | 'personal' | 'product'
}>

export type TelemetryEvent =
  | Readonly<{
      data: LearningTelemetryContext & Readonly<{ cardCount: number }>
      name: 'learning.session_viewed'
    }>
  | Readonly<{
      data: LearningTelemetryContext &
        Readonly<{ playback: 'completed' | 'idle' | 'paused' | 'playing' }>
      name: 'learning.playback_changed'
    }>
  | Readonly<{
      data: LearningTelemetryContext &
        Readonly<{
          intent: 'harder' | 'master'
          outcome: 'failed' | 'succeeded'
        }>
      name: 'learning.grade_finished'
    }>
  | Readonly<{
      data: LearningTelemetryContext &
        Readonly<{ outcome: 'failed' | 'succeeded' }>
      name: 'learning.undo_finished'
    }>
  | Readonly<{
      data: LearningTelemetryContext &
        Readonly<{ outcome: 'failed' | 'succeeded' }>
      name: 'learning.reset_finished'
    }>

export type TelemetryEnvelope = Readonly<{
  anonymousSessionId: string
  event: TelemetryEvent
  occurredAt: string
  schemaVersion: typeof telemetrySchemaVersion
  sequence: number
}>

export interface TelemetryPort {
  track(event: TelemetryEvent): void
}

export const noopTelemetry: TelemetryPort = Object.freeze({
  track: () => undefined,
})
